// extracted by mini-css-extract-plugin
export default {"root":"FilterPicker_root__f6kEF","indicator":"FilterPicker_indicator__r4etb"};